(function () {
  if (window.stockmartMulticolumnLoaded) return;
  window.stockmartMulticolumnLoaded = true;

  const sections = new Map();

  const initSection = (section) => {
    if (sections.has(section)) return;
    const element = section.querySelector(".swiper--multicolumn");
    if (!element) return;
    let swiperMulticolumn;

    const destroySlider = () => {
      if (swiperMulticolumn?.initialized && !swiperMulticolumn.destroyed) {
        swiperMulticolumn.destroy(true, true);
      }
      swiperMulticolumn = null;
      element.querySelectorAll(".multicolumn-list__item").forEach((slide) => {
        slide.removeAttribute("style");
        slide.classList.remove("swiper-slide");
      });
    };

    const observer = new ResizeObserver((entries) => {
      if (!sections.has(section)) return;
      const [entry] = entries;
      if (entry.contentRect.width >= 991) {
        destroySlider();
        return;
      }
      if (swiperMulticolumn) return;
      element.querySelectorAll(".multicolumn-list__item").forEach((slide) => {
        slide.classList.add("swiper-slide");
      });
      swiperMulticolumn = new Swiper(element, {
        loop: false,
        breakpoints: {
          320: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
          },
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 24,
          },
        },
        simulateTouch: true,
        allowTouchMove: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        mousewheel: {
          forceToAxis: true,
        },
        pagination: {
          el: section.querySelector(".multicolumn__pagination"),
          type: "fraction",
        },
        navigation: {
          nextEl: section.querySelector(".multicolumn__button-next"),
          prevEl: section.querySelector(".multicolumn__button-prev"),
        },
      });
    });

    sections.set(section, () => {
      observer.disconnect();
      destroySlider();
      sections.delete(section);
    });
    observer.observe(section);
  };

  const initSections = (root) => {
    if (root.matches?.(".multicolumn-section")) initSection(root);
    root.querySelectorAll(".multicolumn-section").forEach(initSection);
  };

  initSections(document);
  document.addEventListener("shopify:section:load", (event) => {
    initSections(event.target);
  });
  document.addEventListener("shopify:section:unload", (event) => {
    sections.forEach((dispose, section) => {
      if (event.target === section || event.target.contains(section)) dispose();
    });
  });
})();
